const hideLoader = () => $(".search-loader").hide()

// Turnstile widget ID for search landing - used to reset instead of re-render
let searchLandingWidgetId = null

const loadResults = function (token) {
  const domain = $("#domain-name").text()
  let trialResultsFrame = document.getElementById("trial-domain-search-results")

  trialResultsFrame.src = `/trial/v2/domain-search.html?domain=${domain}&cf-turnstile-response=${token}&locale=${i18n.locale}`
  trialResultsFrame.reload()

  // When the frame is loaded
  trialResultsFrame.loaded.then(function () {
    hideLoader()

    // Show sources
    $(".sources-link").on("click", function () {
      if ($(this).parents(".ds-result").find(".ds-sources-list").is(":visible")) {
        $(this).parents(".ds-result").find(".ds-sources-list").slideUp(300)
        return $(this).find(".fa-angle-up").removeClass("fa-angle-up").addClass("fa-angle-down")
      } else {
        $(this).parents(".ds-result").find(".ds-sources-list").slideDown(300)
        return $(this).find(".fa-angle-down").removeClass("fa-angle-down").addClass("fa-angle-up")
      }
    })

    App.tooltip(".ds-results [data-bs-toggle='tooltip']")
    $(".search-cta").removeClass("d-none")
  })
}

document.addEventListener("turbo:load", function () {
  let turnstileInterval
  if (!App.currentPageIs("search_landing_page", "show")) {
    return
  }

  return (turnstileInterval = setInterval(function () {
    // Ensure Turnstile is fully loaded before launching the search
    //
    if (window.turnstile) {
      if (searchLandingWidgetId) {
        turnstile.reset(searchLandingWidgetId)
      } else {
        searchLandingWidgetId = turnstile.render("#turnstile-search-landing", {
          sitekey: gon.turnstile_invisible_site_key,
          size: "invisible",
          callback: (token) => loadResults(token),
        })
      }

      clearInterval(turnstileInterval)
    }
  }, 100))
})
